import Vue from 'vue';

const AttendanceService = {

    findByStudentIds: async function(studentIds) {
        const url = '/student-attendance/by-student-ids';
        const params = {
            student_ids: studentIds ? studentIds.join(','):null
        }
        return await Vue.axios.get(url, {params})
            .then(resp => {
                return resp.data;
            })
            .catch( (error) => {
                throw error
            })
    },

    searchAttendances: async function(studentIds, programIds, startDate, endDate) {
        const url = '/student-attendance/search';
        const params = {
            student_ids: studentIds ? studentIds.join(','):null,
            program_ids: programIds ? programIds.join(','):null,
            start: startDate,
            end: endDate,
        }
        return await Vue.axios.get(url, {params})
            .then(resp => {
                return resp.data;
            })
            .catch( (error) => {
                throw error
            })
    },

    saveAllAttendances: async function(attendances) {
        if (!attendances) {
            throw new Error("The attendances argument cannot be null or undefined");
        }
        if(attendances.length < 1){
            return null;
        }
        
        const url = '/student-attendance/batch';
    
        // Structure of the expected attendance object
        const attendanceTemplate = {
            attendanceId: null,
            scheduleId: null,
            programId: null,
            teacherId: null,
            status: null,
            note: null,
            attendedDate: null,
        };
    
        // Structure of the batch request object
        const updateAttendanceBatchRequestTemplate = {
            updateAttendanceRequests: [],
            date: null
        };
    
        // Group attendances by date
        let groupedAttendances = attendances.reduce((groups, attendance) => {
            let date = attendance.attendedDate;
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(attendance);
            return groups;
        }, {});
    
        // Iterate over each group and make a separate POST request
        let responses = [];
        for (let date in groupedAttendances) {
            let attendancesForDate = groupedAttendances[date];
    
            // Populate the batch request object with actual data
            let updateAttendanceBatchRequest = { ...updateAttendanceBatchRequestTemplate };
            updateAttendanceBatchRequest.updateAttendanceRequests = attendancesForDate.map(a => ({ ...attendanceTemplate, ...a }));
            updateAttendanceBatchRequest.date = date; // Set the date for the batch
    
            try {

                console.log('saving date: ' + date);

                
                let response = await Vue.axios.post(url, updateAttendanceBatchRequest);
                // console.log(`Attendance data for ${date} saved successfully!`);
                responses.push(response.data); // Capture the response data
            } catch (error) {
                // console.error(`An error occurred while saving attendance data for ${date}:`, error);
                // Push the error into responses
                responses.push(error);
            }
        }
    
        return responses;
    },
    

    fetchStudentAttendanceBySchedule: async (studentSchedule, startDate, endDate) => {
        const { studentId, programId } = studentSchedule;
        // Fetch attendances
        let attendances = await AttendanceService.searchAttendances(
          [studentId],
          [programId],
          startDate,
          endDate
        );
  
        // Group attendances by status
        let attendanceStatusGroup = { count: {} };
        if (attendances) {
          attendances.forEach((attendance) => {
            const status = attendance.status.toLowerCase();
            if (!attendanceStatusGroup.count[status]) {
              attendanceStatusGroup.count[status] = 0;
            }
            attendanceStatusGroup.count[status]++;
          });
        }
  
        attendanceStatusGroup.data = attendances;
        return attendanceStatusGroup;
      }
};

export default AttendanceService;
